import { UserOut } from '@/services/noteGoApi/noteGoApiSchemas';
import { TRIAL_DETECTION } from '@/constants/subscriptionConstants';

export interface TrialStatus {
  isOnTrial: boolean;
  daysRemaining: number;
  expiresAt: Date | null;
}

export function getTrialStatus(userData: UserOut | null): TrialStatus {
  if (!userData || !userData.subscription) {
    return { isOnTrial: false, daysRemaining: 0, expiresAt: null };
  }

  const subscription = userData.subscription;

  // Check if this is a trial subscription using centralized logic:
  // 1. scheduled_to_end is true
  // 2. product_name contains "trial" (case insensitive) like "Pro Trial", "Free Trial"
  // 3. status is "active"
  // 4. id is empty string or null (no actual subscription ID)
  // 5. current_period_end exists
  const isTrialSubscription = TRIAL_DETECTION.isTrialSubscription(subscription);

  if (!isTrialSubscription) {
    return { isOnTrial: false, daysRemaining: 0, expiresAt: null };
  }

  // Calculate days remaining from current_period_end
  const trialEndDate = new Date(subscription.current_period_end!);
  const now = new Date();
  const millisecondsRemaining = trialEndDate.getTime() - now.getTime();
  const daysRemaining = Math.ceil(millisecondsRemaining / (1000 * 60 * 60 * 24));

  // Only consider it an active trial if there are days remaining
  const isOnTrial = daysRemaining > 0;

  return {
    isOnTrial,
    daysRemaining: Math.max(0, daysRemaining), // Don't return negative days
    expiresAt: isOnTrial ? trialEndDate : null, // Only return date if still on trial
  };
}
